import { Component, OnInit } from '@angular/core';
import { Animacao } from '../../../core/tools/animacao';
import {
  DashboardVendaInternaGerencialResumo,
  DashboardVendaInternaGerencialService,
  DashboardVendaInternaGerencialVendedor
} from '../../../core/services/dashboard/venda-interna-gerencial/dashboard-venda-interna-gerencial.service';

@Component({
  selector: 'app-dashboard-venda-interna-gerencial',
  templateUrl: './dashboard-venda-interna-gerencial.component.html',
  styleUrls: ['./dashboard-venda-interna-gerencial.component.css'],
  preserveWhitespaces: false,
  animations: [Animacao],
  standalone: false
})
export class DashboardVendaInternaGerencialComponent implements OnInit {
  carregando: boolean = false;
  dataAtual: Date = new Date();
  ordenacao: 'vendas' | 'realizadas' | 'ganho' | 'total' | 'whatsapp' | 'ligacoes' = 'vendas';

  resumo: DashboardVendaInternaGerencialResumo = {
    totalLigacoes: 0,
    totalRealizadas: 0,
    totalLigacaoGanho: 0,
    totalLigacaoPerda: 0,
    percentualRealizadas: 0,
    totalWhatsapp: 0,
    totalWhatsappAtendimento: 0,
    totalWhatsappGanho: 0,
    totalWhatsappPerda: 0,
    totalAtendimentos: 0,
    totalGanhos: 0,
    totalPerdas: 0,
    percentualGanhoGeral: 0,
    totalVendas: 0,
    totalLitros: 0,
    totalPedidos: 0,
    totalNaoComprou: 0,
    podeAtualizarFotos: false,
    vendedores: []
  };

  constructor(private dashboardVendaInternaGerencialService: DashboardVendaInternaGerencialService) { }

  ngOnInit() {
    this.atualizar();
  }

  atualizar() {
    this.carregando = true;
    this.dashboardVendaInternaGerencialService.getResumo().subscribe(
      resumo => {
        this.resumo = resumo || this.resumo;
        this.resumo.vendedores = this.resumo.vendedores || [];
        this.dataAtual = new Date();
      },
      () => this.carregando = false,
      () => this.carregando = false
    );
  }

  vendedoresOrdenados(): DashboardVendaInternaGerencialVendedor[] {
    return [...this.resumo.vendedores].sort((a, b) => {
      if (this.ordenacao == 'realizadas') {
        return ((b.totalRealizadas || 0) + (b.whatsappAtendimento || 0)) - ((a.totalRealizadas || 0) + (a.whatsappAtendimento || 0));
      }

      if (this.ordenacao == 'ganho') {
        return (b.percentualGanhoGeral || 0) - (a.percentualGanhoGeral || 0);
      }

      if (this.ordenacao == 'total') {
        return (b.totalAtendimentos || 0) - (a.totalAtendimentos || 0);
      }

      if (this.ordenacao == 'whatsapp') {
        return (b.totalWhatsapp || 0) - (a.totalWhatsapp || 0);
      }

      if (this.ordenacao == 'ligacoes') {
        return (b.totalLigacoes || 0) - (a.totalLigacoes || 0);
      }

      return (b.vendas || 0) - (a.vendas || 0);
    });
  }

  largura(percentual: number): number {
    return Math.max(0, Math.min(percentual || 0, 100));
  }

  percentual(valor: number, total: number): number {
    return total > 0 ? (valor || 0) / total * 100 : 0;
  }

  tierGanho(percentual: number): string {
    const valor = percentual || 0;

    if (valor >= 50) {
      return 'tier-alta';
    }

    if (valor >= 25) {
      return 'tier-media';
    }

    return 'tier-baixa';
  }

  foto(vendedor: DashboardVendaInternaGerencialVendedor): string {
    if (vendedor.foto && vendedor.foto.trim() != '') {
      return vendedor.foto.indexOf('data:image') == 0 ? vendedor.foto : 'data:image/jpeg;base64,' + vendedor.foto;
    }

    return 'assets/perfil/perfil_sem_foto.png';
  }

  selecionarFoto(event: Event, vendedor: DashboardVendaInternaGerencialVendedor) {
    const input = event.target as HTMLInputElement;
    const arquivo = input.files && input.files.length > 0 ? input.files[0] : null;

    if (arquivo == null) {
      return;
    }

    if (arquivo.type.indexOf('image/') != 0) {
      alert('Selecione uma imagem.');
      input.value = '';
      return;
    }

    this.converterFotoParaBase64(arquivo).then(foto => {
      this.dashboardVendaInternaGerencialService.updateSellerFoto(vendedor.sellerId, foto).subscribe(retorno => {
        if (retorno) {
          vendedor.foto = foto;
        } else {
          alert('Nao foi possivel atualizar a foto.');
        }
      });
    }).catch(() => alert('Nao foi possivel processar a imagem.'));

    input.value = '';
  }

  private converterFotoParaBase64(arquivo: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const imagem = new Image();

        imagem.onload = () => {
          const canvas = document.createElement('canvas');
          const contexto = canvas.getContext('2d');

          if (contexto == null) {
            reject();
            return;
          }

          let largura = imagem.width;
          let altura = imagem.height;
          const limiteInicial = 420;

          if (largura > altura && largura > limiteInicial) {
            altura = Math.round((altura * limiteInicial) / largura);
            largura = limiteInicial;
          } else if (altura > limiteInicial) {
            largura = Math.round((largura * limiteInicial) / altura);
            altura = limiteInicial;
          }

          let qualidade = 0.86;
          let resultado = '';

          for (let tentativa = 0; tentativa < 12; tentativa++) {
            canvas.width = largura;
            canvas.height = altura;
            contexto.clearRect(0, 0, largura, altura);
            contexto.drawImage(imagem, 0, 0, largura, altura);

            resultado = canvas.toDataURL('image/jpeg', qualidade);

            if (this.tamanhoBase64(resultado) <= 100 * 1024) {
              resolve(resultado);
              return;
            }

            if (qualidade > 0.45) {
              qualidade -= 0.08;
            } else {
              largura = Math.max(120, Math.round(largura * 0.86));
              altura = Math.max(120, Math.round(altura * 0.86));
            }
          }

          if (this.tamanhoBase64(resultado) <= 100 * 1024) {
            resolve(resultado);
          } else {
            reject();
          }
        };

        imagem.onerror = () => reject();
        imagem.src = reader.result as string;
      };

      reader.onerror = () => reject();
      reader.readAsDataURL(arquivo);
    });
  }

  private tamanhoBase64(valor: string): number {
    const base64 = valor.indexOf(',') >= 0 ? valor.split(',')[1] : valor;
    return Math.floor((base64.length * 3) / 4);
  }
}
